import { render } from "./helper-joining-notify.vue?vue&type=template&id=392c6490&scoped=true&ts=true"
import script from "./helper-joining-notify.ts?vue&type=script&lang=ts&external"
export * from "./helper-joining-notify.ts?vue&type=script&lang=ts&external"

import "./helper-joining-notify.scss?vue&type=style&index=0&id=392c6490&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392c6490"]])

export default __exports__